// authContext.js
import React, { useEffect } from 'react';

import { createContext, useContext, useState } from 'react';
import { setLogoutHandler } from './authEvent';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [loggedOut, setLoggedOut] = useState(false);

  const triggerLogout = () => {
    setLoggedOut(true);
  };

  useEffect(() => {
    setLogoutHandler(triggerLogout); // 🔗 expose it globally
  }, []);

  return (
    <AuthContext.Provider value={{ loggedOut, triggerLogout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);